// Timezone configuration for the application
// Hardcoded to CST (America/Chicago) as per requirements

export const APP_TIMEZONE = "America/Chicago"

// Export for use in date/time utilities
export default APP_TIMEZONE 